import React from "react";

import { HeaderRow, StyledDevBanner, Tag } from "./style";

const DevBanner: React.FC = () => (
  <>
    <StyledDevBanner aria-live="polite">
      <HeaderRow className="banner-row">
        <div>
          <Tag>Dev</Tag>
        </div>
        You are using the Dev Website, designed for development
      </HeaderRow>
    </StyledDevBanner>
  </>
);

export default DevBanner;
